<template>
  <div class="export-modal overlay overlay--grow" 
    v-show="exportModalVisible"
  > 
    <transition name="slideDown">
      <div>
        <div 
          ref="target" 
          class="overlay__inner" 
          v-show="exportModalVisible" 
        >
          <div class="pricing-row-config">
            <button class="btn btn-icon pricing-row-config__close" aria-label="close"
              @click.prevent="toggleModal"
            ><i class="fa fa-close"></i></button>

            <h3 class="pricing-row-config__head pricing-row-config__head--left pricing-row-config__head--main pricing-row-config__head--drk"
              @mouseenter="moveable.draggable = true"
              @mouseleave="moveable.draggable = false"
            >Export</h3> 

            <div class="pad-top-20">
              <div v-if="isExporting">

                <!-- Single term -->
                <template v-if="terms.length == 1">
                  <div style="display: inline-block; margin-right: 1em; vertical-align: middle;">
                    <ui-spinner></ui-spinner>
                  </div> Exporting, please wait...
                </template>

                <!-- Multiple terms -->
                <template v-else>
                  <p>Your export has begun and will be emailed to you when complete.</p>

                  <button type="button" class="mrgn-btm-0" @click="toggleModal">OK</button>
                </template>
              </div>

              <!-- Single term -->
              <div v-else-if="terms.length == 1 && isComplete">
                <p>Your export is ready to download.</p>
                <button type="button" @click="download">Download</button>
              </div>

            </div> 
          </div>
        </div>

        <Moveable
          className="moveable"
          :target="$refs.target"
          :draggable="moveable.draggable"
          :origin="false"
          :hideDefaultLines="true"
          @drag="handleDrag"
        />
      </div>
    </transition>
  </div>
</template>

<script>
import axios from 'axios'
import Moveable from 'vue3-moveable'
import UiSpinner from '../../../../common/components/UiSpinner.vue'

export default {
  props: ['exportModalVisible', 'dataRequestId'],
  components: {
    Moveable,
    UiSpinner,
  },
  data() {
    return {
      isExporting: false,
      isComplete: false,
      exportData: {},
      moveable: {
        draggable: false,
      }
    }
  },
  computed: {
    terms() {
      return this.$store.getters.termLength.filter(item => {
        return item.value != ''
      })
    },
  },
  watch: {
    exportModalVisible(newValue) {
      if (newValue) {
        this.export()
      } else {
        this.cancel()
      }
    }
  },
  methods: {
    reset() {
      this.isExporting = false
      this.isComplete = false
      this.exportData = {}
    },
    async export() {
      this.reset()
      this.isExporting = true

      try {
        const resp = await axios.post('/pricing-calculator/me/data/requests/' + this.dataRequestId + '/export')

        // Single term. Otherwise the export is emailed to the user.
        if (this.terms.length == 1) {
          this.listen(resp.data.id)
        }

      } catch (err) {
        console.error(err)
        this.cancel()
        swal('An unexpected error occurred.')
      }
    },
    cancel() {
      this.reset()
    },
    listen(exportId) {

      // If ther user is authenticated listen on a private channel.
      const userId = this.$store.getters.userId

      if (userId) {
        window.Echo.private(`userexport.${userId}.${exportId}`)
          .listenToAll((event, data) => {
            console.log(event)
            if (event == 'ExportCompleted') {
              this.setExportData(data)
            }
          })
          .listen('ExportCompleted', (e) => {
            this.setExportData(e.export)
          })

      // If not logged-in listen on a public channel.
      } else {
        window.Echo.channel(`export.${exportId}`)
          .listenToAll((event, data) => {
            if (event == 'ExportCompleted') {
              this.setExportData(data)
            }
          })
          .listen('ExportCompleted', (e) => {
            this.setExportData(e.export)
          })
      }
    },
    setExportData(exportData) {
      this.isComplete = true
      this.isExporting = false
      this.exportData = exportData
    },
    download() {
      window.open('/exports/' + this.exportData.id)
      this.toggleModal()
    },
    /**
     * Toggle the modal's visibility.
     *
     * @return {void}
     */
    toggleModal() {
      this.$refs.target.setAttribute('style', 'transform: matrix(1,0,0,1,0,0) translate(0, 0)')
      this.$emit('toggleModal')
    },
    /**
     * Handle the form modal dragging.
     *
     * @return {void}
     */
    handleDrag({ target, transform }) {
      let ogTransform = target.style.transform

      target.style.transform = transform

      let bounding = target.getBoundingClientRect();
      if (bounding.top < 0) {
        target.style.transform = ogTransform
      }
    },
  }
}
</script>
